module.exports = __webpack_public_path__ + "static/media/Resume_JoaoCosta.33e6e22d.pdf";